import React from 'react';
import divider from '../assets/divider.png';
import location1 from '../assets/location1.jpg';
import location2 from '../assets/location2.jpg';
import location3 from '../assets/location3.jpg';
import location4 from '../assets/location4.png';
import Help from './help';
import { Container } from 'react-bootstrap';

const Fr = () => {

    return (
        <>
            <Help lang='fr' />
            <section>
                <Container className='section'>
                    <div className='instructions'>
                        <h1>RALLYE DU PRINTEMPS</h1>
                        <h2>INSTRUCTIONS</h2>
                        <img className='divider' src={divider} alt='Divider' />
                        <p>
                            🌟 Visitez les 4 emplacements de défis indiqués sur cette carte.
                            <br />
                            🔁 Vous pouvez visiter les emplacements dans l'ordre de votre choix.
                            <br />
                            📱 Vous pouvez utiliser votre téléphone pour trouver les emplacements et planifier un trajet sécuritaire.
                            <br />
                            🧩 À chaque emplacement, vous devrez compléter un défi unique. Tous les membres de l'équipe doivent être présents.
                            <br />
                            🎟️ Après chaque défi complété, vous recevrez un jeton.
                            <br />
                            🏃‍♂️ Une fois que votre équipe a récupéré les 4 jetons, retournez à toute vitesse chez Bobino Bagel pour franchir la ligne d'arrivée!
                            <br />
                            ⏱️ La première équipe dont les 4 membres reviennent avec tous les jetons remporte la course!
                        </p>

                    </div>
                </Container>
            </section>
            <div className='location'>
                <img className='location-img' src={location1} alt='Lieu #1' />
                <div className='location-desc'>
                    <Container className='section'>
                        <h3>Lieu #1</h3>
                        <p>
                            Traversez le pont en longeant l'eau et trouvez le club où les membres rament leurs bateaux, doucement sur la rivière. Votre défi vous attend sur la route principale vers l'intérieur.
                        </p>
                    </Container>
                </div>
            </div>
            <div className='location'>
                <img className='location-img' src={location2} alt='Lieu #2' />
                <div className='location-desc'>
                    <Container className='section'>
                        <h3>Lieu #2</h3>
                        <p>
                            Your next challenge awaits in the flats before the place that honours those who served.
                        </p>
                    </Container>
                </div>
            </div>
            <div className='location'>
                <img className='location-img' src={location3} alt='Lieu #3' />
                <div className='location-desc'>
                    <Container className='section'>
                        <h3>Lieu #3</h3>
                        <p>
                            Là où la vie nocturne de Hull s'anime, entre terrasses, musique et énergie, trouvez la place où la ville prend vie.
                        </p>
                    </Container>
                </div>
            </div>
            <div className='location'>
                <img className='location-img' src={location4} alt='Location #4' />
                <div className='location-desc'>
                    <Container className='section'>
                        <h3>Lieu #4</h3>
                        <p>
                            Dans un parc à Hull le long de la rivière, trouvez l'une des plus anciennes maisons de la région, ouverte comme restaurant d'été avec vue sur le Parlement.
                        </p>
                    </Container>
                </div>
            </div>
            <Help lang='fr' />
        </>
    )
}

export default Fr